import { runtime } from './runtime';

export async function clearAccountContactCache() {
    if (!runtime.isNative()) return;
    const { Filesystem, Directory } = await import('@capacitor/filesystem');
    // Inspect the cache root so "folder absent" succeeds while actual storage
    // failures remain visible. Only remove files owned by this app's contact flow.
    const { files } = await Filesystem.readdir({ directory: Directory.Cache, path: '' });
    if (files.some(file => file.name === 'contact-cards')) {
        await Filesystem.rmdir({ directory: Directory.Cache, path: 'contact-cards', recursive: true });
    }
}
